export var MemoCategoryKey;

(function (MemoCategoryKey) {
  MemoCategoryKey["booking_note"] = "booking_note";
  MemoCategoryKey["return_appointment_info_handover"] = "return_appointment_info_handover";
  MemoCategoryKey["client_info_detail"] = "client_info_detail";
  MemoCategoryKey["feedback_from_satisfactory_survey"] = "feedback_from_satisfactory_survey";
  MemoCategoryKey["personalized_supplement_assistant"] = "personalized_supplement_assistant";
  MemoCategoryKey["one_on_one_consultation"] = "one_on_one_consultation";
  MemoCategoryKey["personalized_supplement_consultation"] = "personalized_supplement_consultation";
})(MemoCategoryKey || (MemoCategoryKey = {}));